<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-button class="md-primary" @click="createNewClient"
          >Create New Client</md-button
        >
        <md-card>
          <md-card-header data-background-color="purple">
            <h4 class="title">SSO Clients</h4>
          </md-card-header>
          <md-card-content>
            <div></div>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "sso-management",
  props: [],
  data: function() {
    return {};
  },
  methods: {
    createNewClient: function() {
      this.$router.push("sso-management/create");
    }
  }
};
</script>
